import backend, {CAREGIVER_API, SCHEDULE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createCaregiver = (input) => {
  const url = `${CAREGIVER_API}/caregiver`;
  return backend.post(url, input);
};

const getCaregiver = (
    caregiverRn, loadLatestAnnouncementMessage, loadBio = false, loadShortId = false, loadCaregiverReviews = false, loadInterviews = false,
) => {
  const queryParam = {
    loadLatestAnnouncementMessage,
    loadBio,
    loadShortId,
    loadCaregiverReviews,
    loadInterviews,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}?${query}`;
  return backend.get(url);
};

const queryCaregiver = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${CAREGIVER_API}/caregiver?${query}`;
  return backend.get(url);
};

const updateDescription = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/description`;
  return backend.put(url, body);
};

const updateFile = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/profile_image`;
  return backend.put(url, body);
};

const updateStatus = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/status`;
  return backend.put(url, body);
};

const updateName = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/name`;
  return backend.put(url, body);
};

const addContact = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/contact`;
  return backend.post(url, body);
};

const removeContact = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/contact`;
  return backend.delete(url, body);
};

const updateShortId = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/short_id`;
  return backend.put(url, body);
};

const addClient = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/client`;
  return backend.post(url, body);
};

const removeClient = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/detail/client`;
  return backend.delete(url, body);
};

const updateBioQuestion = (caregiverRn, bioQuestionId, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/bio/question/${bioQuestionId}`;
  return backend.put(url, body);
};

const updateMultipleBioQuestions = (caregiverRn, body) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/bio/questions`;
  return backend.put(url, body);
};

const createMessage = (caregiverRn, input) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/message`;
  return backend.post(url, input);
};

const updateMessage = (caregiverRn, messageRn, input) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/message/${messageRn}`;
  return backend.put(url, input);
};

const addEmoji = (caregiverRn, messageRn, input) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/message/${messageRn}/emoji`;
  return backend.put(url, input);
};

const removeEmoji = (caregiverRn, messageRn, input) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/message/${messageRn}/emoji`;
  return backend.delete(url, input);
};

const removeMessage = (caregiverRn, messageRn) => {
  const url = `${CAREGIVER_API}/caregiver/${caregiverRn}/message/${messageRn}`;
  return backend.delete(url);
};

const loadMoreMessages = (caregiverRn, lastKey, loadSubmittedByData, loadEmojiRequesters) => {
  const queryParam = {
    lastEvaluatedKey: lastKey,
    loadSubmittedByData,
    loadEmojiRequesters,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CAREGIVER_API}/caregiver/${caregiverRn}/message?${query}`);
};

const loadLogs = (caregiverRn, lastEvaluatedKey, loadRequesterData) => {
  const queryParam = {
    lastEvaluatedKey,
    loadRequesterData,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CAREGIVER_API}/caregiver/${caregiverRn}/log?${query}`);
};

const loadScheduleByMonth = (caregiverRn, byMonths, loadCaregiverUpdates) => {
  const body = {
    byMonths,
    loadCaregiverUpdates,
  };

  return backend.post(`${SCHEDULE_API}/schedule/caregiver/${caregiverRn}`, body);
};

const loadScheduleByIsoRange = (caregiverRn, start, end, loadCaregiverUpdates) => {
  const body = {
    isoRange: {
      start,
      end,
    },
    loadCaregiverUpdates,
  };

  return backend.post(`${SCHEDULE_API}/schedule/caregiver/${caregiverRn}`, body);
};

const addReview = (caregiverRn, body) => {
  return backend.post(`${CAREGIVER_API}/caregiver/${caregiverRn}/review`, body);
};

const removeReview = (caregiverRn, caregiverReviewRn) => {
  return backend.delete(`${CAREGIVER_API}/caregiver/${caregiverRn}/review/${caregiverReviewRn}`);
};

const addRecommendation = (caregiverRn, body) => {
  return backend.post(`${CAREGIVER_API}/caregiver/${caregiverRn}/recommendation`, body);
};

const getInterview = (caregiverRn, interviewRn) => {
  return backend.get(`${CAREGIVER_API}/caregiver/${caregiverRn}/interview/${interviewRn}`);
};

export default {
  createCaregiver,
  getCaregiver,
  queryCaregiver,

  updateDescription,
  updateStatus,
  updateFile,
  updateName,
  addContact,
  removeContact,
  updateShortId,
  addClient,
  removeClient,
  addReview,
  removeReview,
  addRecommendation,

  bioQuestion: {
    update: updateBioQuestion,
    updateMultiple: updateMultipleBioQuestions,
  },

  message: {
    create: createMessage,
    update: updateMessage,
    delete: removeMessage,
    load: loadMoreMessages,

    emoji: {
      add: addEmoji,
      remove: removeEmoji,
    },
  },

  loadLogs,

  schedule: {
    loadByMonth: loadScheduleByMonth,
    loadByIsoRange: loadScheduleByIsoRange,
  },

  interview: {
    get: getInterview,
  },
};
